import type { LoanProductPreviewRender } from "../../../lib/agent-types";
import {
  formatPercent,
  getEffectiveRatePercent,
} from "../../../lib/financials";
import { formatLoanProduct } from "../render-registry.helpers";
import { WidgetFrame, WidgetPlaceholderRow } from "../widget-frame";
import {
  hasMinDownIneligibleFlag,
  PRODUCT_MINIMUM_NOT_MET_LABEL,
} from "./review-flags";

export function LoanProductPreviewWidget({
  payload,
}: {
  payload: LoanProductPreviewRender;
}) {
  return (
    <WidgetFrame data-widget-type="loan_product_preview">
      <ul className="divide-y divide-border-soft">
        {payload.estimate.results.map((result) => (
          <li
            key={result.raw.product}
            className="flex items-center justify-between gap-3 py-2"
            data-product={result.raw.product}
          >
            <span className="min-w-0 text-sm text-foreground">
              <span>{formatLoanProduct(result.raw.product)}</span>
              {hasMinDownIneligibleFlag(result.labels.review_flags) ? (
                <span className="mt-1 block text-xs font-medium text-warning">
                  {PRODUCT_MINIMUM_NOT_MET_LABEL}. Raise down payment for this
                  product.
                </span>
              ) : null}
            </span>
            <span className="shrink-0 text-sm font-bold tabular-nums text-foreground">
              {formatPercent(getEffectiveRatePercent(result), 2)}
            </span>
          </li>
        ))}
        {payload.estimate.results.length === 0 ? (
          <WidgetPlaceholderRow label="No priced products" value="—" />
        ) : null}
      </ul>
    </WidgetFrame>
  );
}
